import { useMutation } from '@tanstack/react-query';
import { createDashboard } from '@src/api/dashboards';

function useSaveDashboard() {
  const saveMutation = useMutation(createDashboard);

  return { saveMutation };
}

export default useSaveDashboard;